import React, { useState } from "react";

import Modal from "../../ui-components/Modal";

import useCountryAxiosInstance from "../../hooks/useCountryAxiosInstance";
import Button from "../../ui-components/Button";
import { useIntl, FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";

import {
  WORKSITE_STATUS_CHOICES,
  WORKSITE_DEACTIVATE_REASON_CODES,
  DEFAULT_WORKSITE_STATUS_DATA,
} from "../../utils/constants";

import { set_worksite_status } from "../../utils";
import Select from "../../ui-components/Select";

function WorksiteDeactivateModal({
  closeModal,
  selectedWorksite,
  toggleDeactivateWorksiteDialog,
  countryCode,
  userData,
  onUpdate,
}) {
  const countryApiRequest = useCountryAxiosInstance();
  const intl = useIntl();

  const [reason, setReason] = useState("");
  const { push } = useHistory();

  const deactivateWorksite = async () => {
    let cancel = false;
    try {
      // merge worksite status with new/default statuses
      const cod_worksite_status = {
        ...DEFAULT_WORKSITE_STATUS_DATA,
        ...selectedWorksite.cod_worksite_status,
      };
      const selectedStep = {
        id: WORKSITE_STATUS_CHOICES.indexOf("deactivated") + 1,
      };
      // aggiungi stato per cantiere vecchio
      const payload = set_worksite_status(
        cod_worksite_status,
        selectedStep,
        userData,
        reason
      );
 
      const result = await countryApiRequest.put(
        `/worksites/${selectedWorksite.id}/update_status`,
        payload
      );
      push({
        title: intl.formatMessage({ id: "worksite_updated_successfully" }),
        type: "success",
      });
      onUpdate(result);
      if (!cancel) {
        toggleDeactivateWorksiteDialog();
      }
    } catch (error) {
      if (!cancel) {
        console.log("errore", error);
      }
    }
  };

  return (
    <Modal onExit={closeModal}>
      <div className="flex w-full flex-col h-full items-center justify-center p-4">
        <label className="ml-2 block text-m text-black-500">
          <FormattedMessage id="confirm_worksite_deactivate" />
          <Select
            className={"my-5"}
            options={WORKSITE_DEACTIVATE_REASON_CODES.map((reasoncode) => ({
              name: intl.formatMessage({
                id: reasoncode,
              }),
              value: reasoncode,
            }))}
            onChange={(e) => {
              setReason(e.target.value);
            }}
            label={intl.formatMessage({
              id: "confirm_worksite_deactivate_reason",
            })}
          />
        </label>
        <div className="w-full mt-4 flex justify-center">
          <Button variant="contained" color="primary" onClick={deactivateWorksite}>
            <FormattedMessage id="deactivate" />
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default WorksiteDeactivateModal;
